import styled from 'styled-components/macro';
import { DeviceSize } from '../basic/DeviceSize';

export const CardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin: 50px 0;

  h4 {
    width: 100%;
    font-size: 18px;
  }

  svg {
    width: 32px;
    height: 32px;
    margin-left: 10px;
  }

  @media ${DeviceSize.desktopS} {
    grid-template-columns: repeat(2, 1fr);
  }

  @media ${DeviceSize.mobileL} {
    display: flex;
    flex-direction: column;

    h4 {
      font-size: 16px;
    }
  }
`;
